define([
	"dojo/_base/declare",
	"csi/html/View",
	"csi/util"
], function(declare,HtmlView,util) {

	return declare(HtmlView, {
		_types: ["DataSheet","Html"],
		m_bSlim: true,

		// Boolean: repeat first view for each page in data sheet
		repeatFirstView: true,

		constructor: function(xn) {
			this.repeatFirstView = util.getBooleanProperty(xn, "RepeatFirstView", true);
		}
	});
});
